module.exports = __webpack_public_path__ + "static/media/IconReportScore.a7eaee9a.svg";